export interface MqttCredentials {
  username: string;
  password: string;
}

export interface ResolveMqttCredentialsInput {
  username: string;
  accessToken: string;
}

/**
 * 与 mqttService 一致的 Broker 凭证策略：
 * - 配置了 REACT_APP_MQTT_USERNAME 时使用固定账号（如 admin/public）
 * - 否则使用登录用户名 + JWT access token 作为 password
 */
export function resolveMqttCredentials(input: ResolveMqttCredentialsInput): MqttCredentials {
  const envMqttUser = process.env.REACT_APP_MQTT_USERNAME?.trim();
  const envMqttPass = process.env.REACT_APP_MQTT_PASSWORD ?? '';
  if (envMqttUser) {
    return { username: envMqttUser, password: envMqttPass };
  }
  return {
    username: input.username,
    password: input.accessToken,
  };
}
